<script lang="ts">
import { Icon, uniqueId } from '@viamrobotics/prime-core';

export let onExtend: () => void;
export let onCancel: () => void;

const menuID = uniqueId('active-try-banner-menu');

let isMenuOpen = false;

const openMenu = () => (isMenuOpen = true);
</script>

<button
  class="ml-auto block justify-end sm:hidden"
  aria-haspopup="menu"
  aria-controls={menuID}
  aria-expanded={isMenuOpen}
  aria-label="Try viam options"
  on:click={openMenu}
>
  <Icon
    cx="flex rotate-90 justify-end text-white"
    size="sm"
    name="dots-horizontal"
  />
</button>

<!-- Mobile menu -->
{#if isMenuOpen}
  <div
    id={menuID}
    role="menu"
    class="absolute -bottom-32 right-2.5 z-10 block gap-2 whitespace-nowrap border border-[#4E4F52] bg-white px-3 sm:hidden"
  >
    <div class="flex flex-col gap-1 text-default">
      <button
        class="h-10 px-2 py-1 text-left hover:bg-gray-8"
        on:click={() => {
          onExtend();
          isMenuOpen = false;
        }}
      >
        Extend
      </button>
      <button
        class="h-10 px-2 py-1 text-left hover:bg-gray-8"
        on:click={() => {
          onCancel();
          isMenuOpen = false;
        }}
      >
        Cancel
      </button>
      <a
        class="flex h-10 items-center px-2 py-1 no-underline hover:bg-gray-8"
        href="https://docs.viam.com/tutorials/control/drive-rover/"
        target="_blank"
      >
        Tutorial & FAQ
      </a>
    </div>
  </div>
{/if}

<!-- Tablet/Desktop links -->
<div class="hidden w-full items-center justify-end gap-2 sm:flex">
  <button
    class="h-fit px-2 py-1 hover:bg-gray-8"
    on:click={onExtend}
  >
    Extend
  </button>
  <button
    class="h-fit px-2 py-1 hover:bg-gray-8"
    on:click={onCancel}
  >
    Cancel
  </button>
  <a
    class="flex h-fit items-center px-2 py-1 hover:bg-gray-8"
    href="https://docs.viam.com/tutorials/control/drive-rover/"
    target="_blank"
  >
    Tutorial & FAQ
  </a>
</div>
